var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "public-transport-selection" }, [
    _c(
      "div",
      { staticClass: "public-transportation-modal" },
      [
        _c("p", [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t(
                  "checkout.personalisation.publicTransport.orderTextSingle"
                )
              ) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _vm.additionalOrderItemConfig
          ? [
              _c("public-transport-item", {
                attrs: { aoic: _vm.additionalOrderItemConfig },
                on: {
                  updateAdditionalOrderItemConfig: function ($event) {
                    return _vm.updateAdditionalOrderItemConfig()
                  },
                },
              }),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }